(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/products-grid-widget/assets/javascripts/query-draw-data-async.js') >= 0) return;  svs.modules.push('/components/sport/products-grid-widget/assets/javascripts/query-draw-data-async.js'); "use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



(function () {
  'use strict';

  const trinidad = svs.isServer ? require('trinidad-core').core : svs.core;
  const {
    getProductBrand
  } = svs.isServer ? 
  require('../../../../lb-utils/brand-mapping/assets/javascripts/brand-mapping.es6') : svs.components.lbUtils.brandMapping;
  const mockableImports = svs.isServer ? {
    getJackpots: trinidad.components.require('content', 'shared').jackpots.getJackpots,
    ttlCache: new trinidad.ttlcache()
  } : {
    getJackpots: () => null,
    ttlCache: {
      get: () => null,
      set: () => null
    }
  };
  const ONE_MINUTE = 60 * 1000;
  const FRIDAY = 5;
  const SATURDAY = 6;
  const ALL_POOL_BRANDINGS_BY_PRIORITY = ['stryktipset', 'europatipset', 'em-tipset', 'vm-tipset', 'topptipset', 'powerplay', 'bomben', 'challenge', 'matchen', 'maltipset'];
  const ALL_SPORT_IDS = ['1000002', '1000003', '1000005', '1000006', '1000011', '1000041', '1000063', '1000043', '1000052', '1000047', '1000022', '1000017', '1000049', '1000023', '1000033', '1000046'];

  async function queryDrawDataAsync(_ref) {
    let {
      itemConfig,
      cacheKey,
      req
    } = _ref;

    const preselection = _getPreselectionIfApplicable({
      itemConfig
    });

    const cachedResult = mockableImports.ttlCache.get(cacheKey);
    const hasCachedResultWhichMatchesPreselection = cachedResult && cachedResult.preselection && cachedResult.preselection.branding === preselection.branding && cachedResult.preselection.brandingIfDrawDataExists === preselection.brandingIfDrawDataExists;

    if (hasCachedResultWhichMatchesPreselection) {
      return cachedResult;
    }

    const sortedDrawResponse = await _queryDraws({
      req,
      productName: preselection.branding,
      sort: 'cancelCloseTime;asc',
      hasToQueryManyResults: Boolean(preselection.brandingIfDrawDataExists)
    });

    const drawData = _getExtractedDataOfBestMatchingDrawItem({
      sortedDrawResponse,
      preselection
    });

    if (drawData) {
      const jackpotData = await mockableImports.getJackpots({
        req,
        product: drawData.branding
      });
      const jackpot = Array.isArray(jackpotData) && jackpotData.length > 0 && !jackpotData[0].defaultJackpot ? parseInt(jackpotData[0].jackpotAmount, 10) : null;

      const result = _objectSpread(_objectSpread({}, drawData), {}, {
        jackpot,
        preselection
      });

      mockableImports.ttlCache.set(cacheKey, result, 5 * ONE_MINUTE);
      return result;
    }

    if (preselection.branding) {
      const result = {
        branding: preselection.branding,
        preselection
      };
      mockableImports.ttlCache.set(cacheKey, result, 5 * ONE_MINUTE);
      return result;
    }

    mockableImports.ttlCache.set(cacheKey, {}, ONE_MINUTE);
    return {};
  }


  function _getPreselectionIfApplicable(_ref2) {
    let {
      itemConfig
    } = _ref2;
    const {
      selectedProduct,
      isOverriddenByStryktipset,
      productsByPriority
    } = itemConfig;
    const allConfiguredProductBrandings = productsByPriority.map(item => item.branding);

    if (allConfiguredProductBrandings.includes(selectedProduct)) {
      return {
        branding: selectedProduct,
        brandingIfDrawDataExists: null
      };
    }

    if (isOverriddenByStryktipset === 'friday-saturday') {
      const currentWeekday = new Date().getDay();

      if (currentWeekday === FRIDAY || currentWeekday === SATURDAY) {
        return {
          branding: null,
          brandingIfDrawDataExists: 'stryktipset'
        };
      }
    }

    return {
      branding: null,
      brandingIfDrawDataExists: null
    };
  }


  async function _queryDraws(_ref3) {
    let {
      req,
      productName,
      sort,
      hasToQueryManyResults = false
    } = _ref3;
    const TOPPTIPSET_PRODUCT_TYPES = 'topptipset,topptipsetextra,topptipsetstryk';
    const ALL_POOL_PRODUCT_TYPES = "challenge,bomben,stryktipset,europatipset,powerplay,maltipset,matchen,".concat(TOPPTIPSET_PRODUCT_TYPES);
    const DELIVERED_DRAW_FIELDS = ['drawNumber', 'productId', 'userProduct', 'regCloseTime', 'currentNetSale', 'fund.extraMoney', 'sport.id'];
    const parameters = {
      ctx: 'draw',
      type: productName === 'topptipset' ? TOPPTIPSET_PRODUCT_TYPES : productName || ALL_POOL_PRODUCT_TYPES,
      orfilter: ALL_SPORT_IDS.map(id => "payload.draw.sport.id;".concat(id)).join(','),
      includes: DELIVERED_DRAW_FIELDS.map(key => "payload.draw.".concat(key)).join(','),
      count: hasToQueryManyResults ? 200 : 20
    };

    if (sort) {
      const sortField = sort.split(';')[0];
      parameters.sort = "payload.draw.".concat(sort);
      parameters.includes += ",payload.draw.".concat(sortField);
    }

    const queryString = Object.keys(parameters).map(key => "".concat(key, "=").concat(encodeURIComponent(parameters[key]))).join('&');
    return trinidad.jupiter.callAsync({
      method: 'GET',
      path: "/search/1/query?".concat(queryString),
      req
    });
  }


  function _getExtractedDataOfBestMatchingDrawItem(_ref4) {
    let {
      sortedDrawResponse,
      preselection
    } = _ref4;

    if (!sortedDrawResponse) {
      return null;
    }

    const allSortedDraws = sortedDrawResponse.result.map(responseItem => responseItem.payload.draw);

    if (allSortedDraws.length === 0) {
      return null;
    }

    const preselectedBranding = preselection.branding || preselection.brandingIfDrawDataExists;

    if (preselectedBranding) {
      const rawDraw = allSortedDraws.find(draw => getProductBrand(draw.productId, draw.subProductId) === preselectedBranding);

      if (rawDraw) {
        return _extractDrawData(rawDraw).data;
      }

      if (preselection.branding) {
        return null;
      }
    }

    const earliestCloseTime = allSortedDraws[0].cancelCloseTime;
    const drawsWithEarliestCloseTime = allSortedDraws.filter(draw => draw.cancelCloseTime === earliestCloseTime).map(_extractDrawData).filter(item => item !== null);
    const bestProductPriority = Math.min(...drawsWithEarliestCloseTime.map(item => item.productPriority));
    const rawDraw = drawsWithEarliestCloseTime.find(item => item.productPriority === bestProductPriority);
    return rawDraw ? rawDraw.data : null;
  }


  function _extractDrawData(drawItem) {
    if (!drawItem) {
      return null;
    }

    const {
      drawNumber,
      productId,
      subProductId,
      regCloseTime,
      currentNetSale,
      fund
    } = drawItem;
    const branding = getProductBrand(productId, subProductId);
    const productPriority = ALL_POOL_BRANDINGS_BY_PRIORITY.indexOf(branding) + 1;
    const extraMoney = parseInt(currentNetSale, 10) || parseInt(fund ? fund.extraMoney : 0, 10);
    return productPriority > 0 ? {
      drawNumber,
      productPriority,
      data: {
        branding,
        closeTime: regCloseTime,
        extraMoney
      }
    } : null;
  } 


  if (svs.isServer) {
    module.exports = {
      queryDrawDataAsync
    };
  } else {
    setGlobal('svs.sport.productsGridWidget.queryDrawDataAsync', queryDrawDataAsync); 

    setGlobal('svs.sport.productsGridWidget.testInternals.queryDrawDataAsync.getMockableImports', () => mockableImports);
  }
})();
 })(window);